export var DisplayType;
(function (DisplayType) {
    DisplayType["Body"] = "body";
    DisplayType["SubHeader"] = "subHeader";
    DisplayType["ListItems"] = "listItems";
})(DisplayType || (DisplayType = {}));
export var FieldName;
(function (FieldName) {
    FieldName["FirstName"] = "firstName";
    FieldName["LastName"] = "lastName";
    FieldName["JobTitleInternal"] = "orgJobTitle";
    FieldName["EmployeeSourceId"] = "employeeNumber";
    FieldName["DateOfHire"] = "dateOfHire";
    FieldName["ManagerSourceId"] = "managerNumber";
    FieldName["WorkEmail"] = "workEmail";
    FieldName["AnnualOrHourly"] = "annualOrHourly";
    FieldName["IsoCurrencyCode"] = "currency";
    FieldName["CountryCode"] = "countryCode";
    FieldName["StandardWorkHours"] = "standardWorkHours";
    FieldName["MissingUser"] = "missingUser";
    FieldName["DuplicateEmail"] = "duplicateEmail";
    FieldName["All"] = "All";
})(FieldName || (FieldName = {}));
export var FieldDisplayName;
(function (FieldDisplayName) {
    FieldDisplayName["FirstName"] = "First Name";
    FieldDisplayName["LastName"] = "Last Name";
    FieldDisplayName["JobTitleInternal"] = "Job Title";
    FieldDisplayName["EmployeeSourceId"] = "Employee ID";
    FieldDisplayName["HireDate"] = "Hire Date";
    FieldDisplayName["ManagerSourceId"] = "Manager Id";
    FieldDisplayName["WorkEmail"] = "Email Address";
    FieldDisplayName["AnnualOrHourly"] = "Pay Type";
    FieldDisplayName["IsoCurrencyCode"] = "Currency Code";
    FieldDisplayName["CountryCode"] = "Country Code";
    FieldDisplayName["StandardWorkHours"] = "Work Hours";
    FieldDisplayName["MissingUser"] = "Missing User";
    FieldDisplayName["DuplicateEmail"] = "Duplicate Email";
    FieldDisplayName["All"] = "All";
})(FieldDisplayName || (FieldDisplayName = {}));
export const fieldCopy = {
    firstName: {
        body: 'Identifies the employee and ties their name to an employee ID.',
        subHeader: 'An error in employee name will:',
        listItems: ['Employees will not be identified by name when Manager’s make pay decisions',
            'Missing first or last name will degrade your manager’s Team experience.']
    },
    lastName: {
        body: 'Identifies the employee and ties their name to an employee ID.',
        subHeader: 'An error in employee name will:',
        listItems: ['Employees will not be identified by name when managers make pay decisions',
            'Missing first or last name will degrade your manager’s Team experience.']
    },
    orgJobTitle: {
        body: 'The employee’s current role within your organization.',
        subHeader: 'An error in job title will:',
        listItems: ['Not show a range or will show the wrong range for the employee.',
            'Make it difficult for a manager to promote an employee to the correct job title.']
    },
    employeeNumber: {
        body: 'The employee number assigned by your org to an employee.' +
            'This is used to identify employees by attaching a name to the employee ID.',
        subHeader: 'An error in employee ID may:',
        listItems: ['Show incorrect employee counts for a manager’s team if an employee is missing.',
            'Affect the manager’s assigned budget if the number of employees is incorrect.',
            'Not display an employee within the manager’s team.']
    },
    dateOfHire: {
        body: 'The date the employee was hired.' +
            'Hire date is used when assigning eligibility and proration rules during your budgeting process.',
        subHeader: 'An error in hire date can:',
        listItems: ['Cause an employee to be marked incorrectly within an eligibility or proration rule.']
    },
    managerNumber: {
        body: 'Identifies who the employee reports to within your org.' +
            ' When a manager logs into Team, they will see all employees assigned to them.' +
            ' Only one employee will have an empty manager ID, this person should be the CEO' +
            ' (or whomever is at the top of the hierarchy).',
        subHeader: 'Common Manager ID errors include:',
        listItems: [
            'A parallel reporting structure if more than one employee has an empty manager ID.',
            'No CEO is identified if all employees are assigned a manager ID.',
            'Invalid manager ID when an employee is assigned a manager ID which does not exist in Insight Lab.',
            'Other errors include employees who have been terminated or incorrect HRIS data.'
        ]
    },
    workEmail: {
        body: 'An email address is used to create a manager’s account—allowing them to login' +
            ' and receive email communication about their team. Email addresses must be unique for each employee.',
        subHeader: 'An error in email address may cause a Manager to:',
        listItems: ['Not be able to login', 'See a blank screen upon login.']
    },
    duplicateEmail: {
        body: 'An email address is used to create a manager’s account—allowing them to login' +
            ' and receive email communication about their team. Email addresses must be unique for each employee.',
        subHeader: 'An error in email address may cause a Manager to:',
        listItems: ['Not be able to login', 'See a blank screen upon login.']
    },
    annualOrHourly: {
        body: 'Defines whether an employee is annual (salaried) or hourly (base pay).' +
            ' The default value is Annual. If an employee is missing pay type, the default will be shown. ' +
            'Their value can be updated in Insight Lab for individual employees.',
        subHeader: '',
        listItems: []
    },
    currency: {
        body: 'The employee’s currency. The employee’s pay will be shown in their assigned currency.' +
            ' The default value is USD. If an employee is missing currency code, the default will be shown.',
        subHeader: 'Errors within currency code:',
        listItems: ['Could be a result of a mismatch with the country code. ' +
                'Ensure the correct currency code is mapped to the country code.',
            'Mismatches can cause data issues when setting your budget.']
    },
    countryCode: {
        body: 'The employee’s country. Country code enables you to group employees ' +
            'by country when budgeting and making pay decisions.' +
            ' The default value is USA. If an employee is missing coutnry code, the default will be shown.',
        subHeader: 'Errors within country code:',
        listItems: ['Could be a result of a mismatch with the currency code.' +
                'Ensure the correct currency code is mapped to the country code.',
            'Mismatches can cause data issues when setting your budget.']
    },
    standardWorkHours: {
        body: 'The number of hours the employee works in a standard week.' +
            ' The default is 40. If an employee is missing standard work hours, the default will be shown.' +
            ' This value can be updated in Insight Lab for individual employees.',
        subHeader: 'Invalid work hours will:',
        listItems: ['Miscalculate an employee’s pay based on the value entered.']
    },
    missingUser: {
        body: 'Managers who have access to Team and can make pay decisions for their reports.',
        subHeader: 'A manager whose user is missing will:',
        listItems: ['Not be able to login', 'Not be able access their team for review']
    }
};
